import { EmailChangeRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * sendPasswordResetByUserEmail - Function that updates the user email  
 * /authenticator/change-mail    
 * method PUT 
 * @async-function
 */
const updateEmailByUserId = async (token: string, model: EmailChangeRequestType) => {
    const response = await api.put(
        `/authenticator/change-mail`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updateEmailByUserId;